import React, { useEffect, useState } from 'react';
import '../scss/Home.scss';
import { config } from '../../../config';
import { StaticHeader, StaticFooter } from '../components';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const body = {
        name,
        email,
        message,
      };

      const response = await fetch(config.API_URI + '/v1/contact', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.details && data.details.length > 0) {
          const errorMessages = data.details.map(detail => detail.msg).join(', ');
          setError(errorMessages);
        } else {
          setError(data.error || 'Failed to send message. Please try again.');
        }
        setLoading(false);
        return;
      }

      setIsSubmitted(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Error submitting message:', error);
      setError('Failed to send message. Please try again or email us directly at zoobbe.inc@gmail.com');
    }

    setLoading(false);
  };

  return (
    <div className="landing-page">
      <StaticHeader />

      <section className="features" style={{ paddingTop: '8rem' }}>
        <div className="container">
          <div className="section-header">
            <h2>Contact Us</h2>
            <p>We’d love to hear from you. Questions, feedback, or partnerships — reach out.</p>
          </div>

          <div className="contact-form-wrapper">
            {isSubmitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Thank you for reaching out!</h3>
                <p>We've received your message and will get back to you soon.</p>
                <button
                  onClick={() => setIsSubmitted(false)}
                  className="hero__signup-btn"
                  style={{ marginTop: '1rem' }}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {error && (
                  <div className="error-message">
                    {error}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="John Doe"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={loading}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="john@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    placeholder="How can we help you?"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows={6}
                    disabled={loading}
                    className="form-input form-textarea"
                  />
                </div>

                <button
                  type="submit"
                  className="hero__signup-btn submit-btn"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Message'}
                </button>

                {/* <p className="form-note">
                  Or email us directly at <a href="mailto:zoobbe.inc@gmail.com">zoobbe.inc@gmail.com</a>
                </p> */}
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <StaticFooter />
    </div>
  );
};

export default Contact;

